import * as React from 'react'

import { ApprovalMaterializedApprovalFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useLazyExpensable } from 'modules/expenses/hooks/useLazyExpensable'
import { expensableCreationType } from 'modules/expenses/lib/expensables/expensable'
import type { RequestComponentProps } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/base'

import BasePendingApproval from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/BasePendingApprovals'
import ExpenseRightBlock from './components/ExpenseRightBlock'
import LeftBlock from './components/LeftBlock'
import MileageRightBlock from './components/MileageRightBlock'
import PerDiemRightBlock from './components/PerDiemRightBlock'
import { CollapseContentData } from './types'

const ExpensesApprovals = ({
  request,
  index,
  compact,
  removeRequestById,
}: RequestComponentProps) => {
  const { company } = useCurrentSession()
  const { fetch } = useLazyExpensable()

  const fetchResources = async (flow: ApprovalMaterializedApprovalFragment) => {
    const expensable = await fetch({
      id: flow.resourceId,
      companyId: company.id,
      includeAttachments: true,
    })
    return expensable!
  }

  const rightBlockByType = (data: CollapseContentData) => {
    switch (data.type) {
      case 'expense':
        return <ExpenseRightBlock collapseContentData={data} />
      case 'mileage':
        return <MileageRightBlock collapseContentData={data} />
      case 'perdiem':
        return <PerDiemRightBlock collapseContentData={data} />
    }
  }

  return (
    <BasePendingApproval
      request={request}
      index={index}
      compact={compact}
      getApprovalData={fetchResources}
      removeRequestById={removeRequestById}
      collapseContentBlocks={(data) => ({
        leftBlock: <LeftBlock type={expensableCreationType(data as CollapseContentData)} />,
        rightBlock: rightBlockByType(data as CollapseContentData),
      })}
    />
  )
}

export default ExpensesApprovals
